import http from "./http";

/**
 * Service for the facturación on-demand flow (Trello #223).
 *
 * Uses the central http instance — no raw axios, no module-scope token reads.
 */
const FacturacionPedidoService = {
  /**
   * Fetches a pedido with its full detail including cliente fiscal data.
   * @param {number} id - Pedido ID
   * @returns {Promise} Axios response; response.data.data contains the pedido
   */
  buscarPedido(id) {
    return http.get(`pedidos/${id}/detalle`);
  },

  /**
   * Emits an ARCA invoice for the given pedido.
   * @param {number} id - Pedido ID
   * @param {object} payload - { fiscal: { condicion_iva, cuit, razon_social }, tipo_comprobante, id_cliente? }
   * @returns {Promise} Axios response; response.data contains the standard envelope
   */
  facturar(id, payload) {
    return http.post(`pedidos/${id}/facturar`, payload);
  },

  /**
   * Returns a lightweight list of clientes for autocomplete (id + nombre).
   * @param {string} [query] - Optional search term
   * @returns {Promise} Axios response; response.data.data contains the array
   */
  buscarClientes(query) {
    return http.get("clientes/resumido", { params: { q: query } });
  },

  /**
   * Returns the full cliente record including fiscal fields.
   * @param {number} id - Cliente ID
   * @returns {Promise} Axios response; response.data.data contains the cliente
   */
  getCliente(id) {
    return http.get(`clientes/${id}`);
  },

  /**
   * Fetches the ticket HTML for a given ARCA transaction UUID.
   * @param {string} uuid - Transaction UUID from facturar response
   * @param {number} [tamanio=384] - Ticket width in pixels (384 or 600)
   * @returns {Promise} Axios response; response.data.data.ticket contains the HTML string
   */
  getTicket(uuid, tamanio = 384) {
    return http.get(`arca/transacciones/${uuid}/ticket`, { params: { tamanio } });
  },
};

export default FacturacionPedidoService;
